export const emptyFunction = () => null;
